import axios from "axios";
import { createContext, useCallback, useEffect, useState } from "react";
import configeToken from "../services/api";
export const ManagerProgressContext = createContext();

function ManagerProgressContextProvider({ children }) {
    const [dataTemas, setDataTemas] = useState([]);
    const [allProgress, setAllProgress] = useState([]);
    const [managerBtn, setManagerBtn] = useState(true);
    const [dataTemaAswered, setDataTemaAswered] = useState(true);
    const [concluded, setConcluded] = useState(false);
    const [lastTheme, setLastTheme] = useState(false);
    const [quizzEndDate, setQuizzEndDate] = useState();

    useEffect(() => {
        const array = [];

        for (let progress in dataTemas) {
            array.push(Math.round(dataTemas[progress].progress));
        }
        setAllProgress(array);
        // const validadeProgress = array.map(el => el === 100)
        // const validateAll100 = validadeProgress.includes(false)
        setManagerBtn(!concluded);
    }, [dataTemas, concluded]);

    const getProgress = useCallback(() => {
        const cyrcleStorage = JSON.parse(localStorage.getItem("@cycleChosed"));
        configeToken();

        const headers = {
            Authorization: ``,
            "Content-Type": "application/json",
            Accept: "application/json",
        };

        if (!cyrcleStorage) return Promise.resolve();

        return axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}/pesquisa/${cyrcleStorage}`,
            headers,
        })
            .then((response) => {
                setDataTemas(response.data.data.themes);
                setDataTemaAswered(response.data.data.themes[0].answered);
                setConcluded(response.data.data.concluded);
                setLastTheme(response.data.data.themes[response.data.data.themes.length - 1].id);
                setQuizzEndDate(response.data.data?.end_date);
            })
            .catch((error) => {
                if (error.response?.status === 429) {
                    console.warn(
                        "API rate limit hit (429), aguarde alguns segundos antes de tentar novamente.",
                    );
                } else {
                    console.error("Erro em getProgress:", error);
                }
            });
    }, []);

    return (
        <ManagerProgressContext.Provider
            value={{
                allProgress,
                getProgress,
                managerBtn,
                dataTemaAswered,
                concluded,
                lastTheme,
                quizzEndDate,
                dataTemas,
            }}
        >
            {children}
        </ManagerProgressContext.Provider>
    );
}

export default ManagerProgressContextProvider;

